import "core-js/modules/es.array.map.js";
import React from 'react';
import { PlusCircle } from '@finect/tabular-icons/plusCircle';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Link } from 'react-router-dom';
import { getPathComparison } from '@finect/front-resources/Products';
import { useTheme } from 'styled-components';
import { CompactTimeseriesComparisonChart } from '../../../Products/Charts';
import { Inner, DetailCardBlock, LegendBlock, Circle, LineName, LegendLine, CircleContainer, ChartContainer, Actions } from './partials';
export var DetailCard = function DetailCard(_ref) {
  var funds = _ref.funds,
    productType = _ref.productType;
  var theme = useTheme();
  var url = getPathComparison(theme, productType, funds);
  return React.createElement(Inner, null, React.createElement(DetailCardBlock, null, React.createElement(ChartContainer, null, React.createElement(CompactTimeseriesComparisonChart, {
    key: funds.map(function (item) {
      return item.id;
    }).join('-'),
    products: funds,
    productType: productType
  })), React.createElement(LegendBlock, null, funds.map(function (fund, index) {
    return React.createElement(LegendLine, {
      key: index
    }, React.createElement(CircleContainer, null, React.createElement(Circle, {
      radius: 5,
      index: index + 1
    })), React.createElement(LineName, null, fund.class ? fund.class.name : fund.name));
  })), React.createElement(Actions, null, React.createElement("div", null, React.createElement(AppLink, {
    to: url,
    as: Link,
    rel: "nofollow"
  }, React.createElement(PlusCircle, {
    size: '18px'
  }), React.createElement("span", null, "Comparar"))))));
};